import { Controller } from "@hotwired/stimulus"

// This file was generated by Gemini AI

export default class extends Controller {
  static targets = [ "query", "item", "section", "empty" ]

  filter() {
    const query = this.queryTarget.value.toLowerCase().trim()
    let totalVisible = 0

    // 1. Filter alle einzelnen Elemente (Ordner & Videos)
    this.itemTargets.forEach(item => {
      const name = item.dataset.searchName.toLowerCase()

      if (name.includes(query)) {
        // Tailwind Klassen wechseln: hidden entfernen, flex wiederherstellen
        item.classList.remove("hidden")
        item.classList.add("flex")
        totalVisible++
      } else {
        item.classList.remove("flex")
        item.classList.add("hidden")
      }
    })

    // 2. Sektionen ("Ordner" / "Videos") intelligent ein- oder ausblenden
    this.sectionTargets.forEach(section => {
      // Zähle, wie viele sichtbare Items noch in dieser speziellen Sektion sind
      const visibleInSection = section.querySelectorAll('[data-search-target="item"]:not(.hidden)').length

      if (visibleInSection === 0 && query !== "") {
        section.classList.add("hidden")
      } else {
        section.classList.remove("hidden")
      }
    })

    // 3. Zeige "Keine Ergebnisse" Nachricht, falls absolut gar nichts matcht
    if (this.hasEmptyTarget) {
      if (totalVisible === 0 && query !== "") {
        this.emptyTarget.classList.remove("hidden")
      } else {
        this.emptyTarget.classList.add("hidden")
      }
    }
  }
}